import React from "react";
import AuthContainer from "../components/AuthContainer/AuthContainer";
import TextWithBackButton from "../components/TextWithBackButton";
import { useNavigate } from "react-router-dom";
import GridLGHidden from "../components/GridComponent/components/GridLGHidden";
import Header from "../components/Header/Header";
import ResetPasswordForm from "../components/ResetPasswordForm/ResetPasswordForm";

const ResetPassword = () => {
  const navigate = useNavigate();

  return (
    <AuthContainer>
      <div className="w-full bg-light-grey-5 lg:rounded-20 lg:min-h-360 relative flex min-h-svh flex-col lg:bg-white px-12  lg:p-24">
        <GridLGHidden>
          <Header />
        </GridLGHidden>
        <TextWithBackButton
          text="Reset password"
          backBtnClick={() => navigate("/login")}
          subText="Enter the email associated with your account and we’ll send an email with instructions to reset password."
        />
        <ResetPasswordForm />
        {/* <Divider />
        <div className="mb-24 flex items-center justify-center">
          <Typography type="Body2" className="text-light-grey-4">
            Not a member yet?
            <Link
              to="/signup"
              className="text-primary decoration-primary underline decoration-1 underline-offset-4 ml-[3px]"
              id="notaMemberYet"
            >
              Sign up
            </Link>
          </Typography>
        </div> */}
      </div>
    </AuthContainer>
  );
};

export default ResetPassword;
